module.exports = __webpack_public_path__ + "static/media/05-submenu2.ad3dda4b.png";